var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tr',_vm._l((_vm.columns),function(col){return (!col.isAssetView)?_c('b-th',{key:col.field,class:col.class,style:(`width: ${col.width || '10vw'}`),attrs:{"id":col.id,"variant":col.variant,"name":col.name}},[_vm._v(_vm._s(col.label))]):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }